"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var JapanOverview3 = function JapanOverview3(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "45",
    height: "22",
    viewBox: "0 0 45 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.176 4.376C17.44 4.712 14.824 4.976 12.352 5.168C11.584 3.68 10.912 2.168 10.36 0.679998L7.984 1.568C8.536 2.936 9.088 4.184 9.64 5.336C7.648 5.432 5.752 5.504 3.976 5.504C3.424 5.504 2.152 5.456 0.16 5.384L0.184 7.832C1.36 7.88 2.632 7.904 4.024 7.904C6.28 7.904 8.536 7.832 10.84 7.712C11.68 9.248 12.52 10.544 13.36 11.552C11.704 11.024 10.072 10.784 8.488 10.784C6.424 10.784 4.744 11.192 3.496 12.056C2.152 12.944 1.504 14.168 1.504 15.728C1.504 17.408 2.2 18.704 3.616 19.664C5.056 20.648 7.096 21.152 9.736 21.152C12.256 21.152 14.392 21.008 16.144 20.72L15.808 18.272C13.84 18.56 11.824 18.728 9.736 18.728C7.864 18.728 6.448 18.44 5.488 17.864C4.576 17.336 4.12 16.64 4.12 15.728C4.12 14.984 4.48 14.384 5.2 13.904C5.992 13.376 7.144 13.112 8.632 13.112C11.032 13.112 13.624 13.64 16.384 14.72L17.68 13.064C16.288 11.6 14.944 9.752 13.648 7.52C15.856 7.328 18.112 7.064 20.392 6.776L20.176 4.376ZM31.024 1.496C28.624 6.896 26.032 13.208 23.272 20.456L25.888 21.128L28.168 15.176C28.528 14.216 29.152 13.352 30.016 12.56C30.88 11.744 31.648 11.36 32.32 11.36C33.064 11.36 33.448 11.912 33.448 13.016C33.448 13.28 33.424 14 33.376 15.152C33.328 16.304 33.304 17 33.304 17.192C33.304 18.392 33.712 19.376 34.528 20.144C35.344 20.888 36.424 21.272 37.768 21.272C39.664 21.272 41.128 20.456 42.16 18.824C43.072 17.408 43.864 14.96 44.536 11.504L41.944 10.976C41.416 14 40.768 16.136 40.048 17.36C39.448 18.32 38.68 18.824 37.768 18.824C37.192 18.824 36.736 18.656 36.4 18.368C36.064 18.08 35.896 17.672 35.896 17.192C35.896 17 35.92 16.304 35.968 15.152C36.016 14 36.04 13.28 36.04 13.016C36.04 11.888 35.776 10.952 35.272 10.232C34.648 9.368 33.784 8.96 32.68 8.96C32.176 8.96 31.672 9.08 31.192 9.32C30.712 9.56 30.256 9.896 29.824 10.328C30.952 7.808 32.2 5.168 33.568 2.408L31.024 1.496Z",
    fill: fill
  }));
};
JapanOverview3.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
JapanOverview3.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = JapanOverview3;